var React = require('react');

function MediumGray (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.6976 6.74856C12.6976 10.0019 10.0782 12.6394 6.84686 12.6394C3.61555 12.6394 0.996338 10.0027 0.996338 6.74856C0.996338 3.49441 3.61575 0.85791 6.84686 0.85791C10.078 0.85791 12.6976 3.4952 12.6976 6.74856ZM19.1159 6.74856C19.1159 9.8112 17.8061 12.2937 16.1905 12.2937C14.575 12.2937 13.2652 9.8104 13.2652 6.74856C13.2652 3.68672 14.575 1.20339 16.1905 1.20339C17.8061 1.20339 19.1159 3.68672 19.1159 6.74856ZM21.7411 6.74856C21.7411 9.49254 21.2803 11.7168 20.7122 11.7168C20.144 11.7168 19.6833 9.49174 19.6833 6.74856C19.6833 4.00538 20.144 1.78032 20.7124 1.78032C21.2807 1.78032 21.7411 4.00478 21.7411 6.74856Z","fill":"#B1B8C3"}));
}

MediumGray.defaultProps = {"width":"22","height":"13","viewBox":"0 0 22 13","fill":"none"};

module.exports = MediumGray;

MediumGray.default = MediumGray;
